import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // if the url contains noscroll then we don't want it to scroll
  // e.g. the article page wehen selecting articles
  const noscroll = pathname.indexOf('noscroll') > -1;

  useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    if (!noscroll && document.documentElement && document.documentElement.scrollTo) {
      document.documentElement.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' // Optional if you want to skip the scrolling animation
      });
    }
  }, [pathname, noscroll]);

  return null;
};

export default ScrollToTop;
